import {
    Component, Input, OnInit
} from '@angular/core';
import { HttpService } from '../../services/http.service';
import { getWindow } from 'ssr-window';
import { HttpErrorResponse } from '@angular/common/http';
import { CfAlertService } from '@crediblefinance/credible-ui';
import { OnboardingService } from '../onboarding.service';

@Component({
    selector: 'app-airdrop-credit-score',
    templateUrl: './airdrop-credit-score.component.html',
    styleUrls: [ './airdrop-credit-score.component.scss' ]
})
export class AirdropCreditScoreComponent implements OnInit {
    @Input() task = {
        id: '',
        title: '',
        desc: '',
        icon: '',
        status: 'Pending',
        reward: 0,
        multiplier: false,
        redirect_url: '',
        cta: '',
        coming_soon: false
    };

    constructor(public httpService: HttpService,
        private cfAlertService: CfAlertService,
        private onboardingService: OnboardingService
    ) {
        this.window = getWindow();
    }

    window: Window;

    generate_credit_score_loading: boolean = false;
    share_credit_score_loading: boolean = false;
    credit_score: any = {};
    progress: number = 0;

    ngOnInit(): void {
        this.attachSocketEvents();
        this.getCreditScore();
    }

    attachSocketEvents() {
        this.httpService.socket.on('generate_credit_score_completed', (data: any) => {
            console.log('generate_credit_score_completed : ', data);
            this.generate_credit_score_loading = false;
            this.credit_score = data;
        });

        this.httpService.socket.on('generate_credit_score_progress', (data: any) => {
            console.log('generate_credit_score_progress : ', data.progress);

            this.progress = data.progress;
        });
    }
    
    getCreditScore() {
        this.httpService.getCreditScore().subscribe(res => {
            console.log('Credit Score : ', res);

            this.credit_score = res.data;
            // this.credit_score = null;
        }, (err: HttpErrorResponse) => {
            console.error(err);
        });
    }

    generateCreditScore() {
        this.httpService.generateCreditScore().subscribe(res => {
            this.generate_credit_score_loading = true;
            this.cfAlertService.showMessage('Credit score is getting generated', false);
        }, (err: HttpErrorResponse) => {
            console.error(err);
        });
    }

    shareCreditScore() {
        this.share_credit_score_loading = true;

        const text = `My credit score on Credible Finance is ${this.credit_score.score}. Check your credit score now!`;
        const hashtags = [
            'credible', 'finance', 'crediblefinance', 'solana', 'creditscore'
        ].join(',');
        const via = 'crediblefin';
        const related = 'crediblefin';

        const data = {
            text: text,
            hashtags: hashtags,
            via: via,
            related: related
        };

        const queryString = new URLSearchParams(data).toString();

        const url = `https://twitter.com/intent/tweet?${queryString}`;

        this.window.open(url, '_blank');

        this.onboardingService.shareCreditScoreOnTwitter().subscribe((res: any) => {
            this.share_credit_score_loading = false;

            if (this.httpService.user.twitter)
                this.httpService.user.twitter.credit_score = true;

            this.task.status = 'Completed';
        }, (err: HttpErrorResponse) => {
            this.share_credit_score_loading = false;

            console.error(err);

            this.cfAlertService.showError(err);
        });
    }
}
